export default __webpack_public_path__ + "static/media/image1.00afc6af.png";